// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"5927b7b2","52":"c91f1d9e","322":"d002e36c","345":"9e2f91e9","488":"1a7cbc08","541":"63971ca9","562":"7380d590"}[chunkId] + ".chunk.js";
};